export default __webpack_public_path__ + "assets/kittenPop2Low.mp3";